import React from 'react'
import "../../../StyleSheet/AppComponent/Popup/Delete.scss";
import DeleteImg from "../../../Assets/AppComponent/Images/delete2.jpg"
const Delete = (props) => {
    const { show, setShow , Content} = props;
    const handleClose = () => {
      setShow(false);
     // props.onClose();
    };
  
    const handleSubmits = (e) => {
      //handleClose();
      // toSubmits()
      props.onSubmit();
    };
  return (
    <div className='DeletePopUp'
    //  onClick={handleClose}
    
    >
        <div className='DeleteClose'>
      <div className='DeleteOutter'>
            <div className='DeletePart'>
              <div className='XMarks'>
                {/* <i class="fa-solid fa-triangle-exclamation"></i> */}
                <img src={DeleteImg}/>
              </div>
            </div>
            <div className='DeleteText'>
              {/* <p>Do You Want to Delete the Data ?</p> */}
              <p>{`${Content} ?`}</p>
            </div>
            <div className='DeleteButton'>
              <button className='DeleteCancel' onClick={handleClose}>Cancel</button>
              <button className='DeleteSave' onClick={handleSubmits}>Delete</button>
            </div>
          </div>
          </div>
    </div>
  )
}

export default Delete
